import { lanzamientoimgs as banners } from "./images";
import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const LanzamientoBanner = () => {
  return (
    <Container>
      <div>
        <picture>
          <source media="(max-width: 768px)" srcSet={banners.mobile} />
          <source media="(max-width: 1024px)" srcSet={banners.tablet} />
          <source media="(max-width: 1366px)" srcSet={banners.standard} />
          <img src={banners.hd} alt="Lanzamiento Fleischmann" />
        </picture>
        {/* <a hidden disabled href="/alimentec" target="blank" className="banner-btn-link" style={{zIndex:1}}> */}
        <a href="/main/Seminarios" target="blank" className="banner-btn-link" style={{zIndex:1}}>
          <Button
            sx={{
              zIndex: 100,
              // backgroundColor: "#cf7647",
              // color: "#fff",
              fontSize: "1.2rem",
              padding: "12px 28px",
              "&:hover": {
                // backgroundColor: "#b86e3a",
              },
              "@media (min-width: 1367px)": {
                fontSize: "1.3rem",
                padding: "8px 32px",
              },
              "@media (max-width: 1366px)": {
                fontSize: "1.3rem",
                padding: "8px 32px",
              },
              "@media (max-width: 1024px)": {
                fontSize: "1.2rem",
                padding: "8px 28px",
              },
              "@media (max-width: 768px)": {
                fontSize: "1.1rem !important",
                padding: "6px 24px",
              },
            }}
            color="secondary"
            variant="contained"
          >
            {/* CONOCER MÁS */}
            QUIERO INSCRIBIRME
          </Button>
        </a>
      </div>
    </Container>
  );
};

const Container = styled.div`
  margin-top: 100px;
  @media (max-width: 768px) {
    margin-top: 70px;
  }

  > div {
    width: 100%;
    margin-inline: auto;
    position: relative;

    picture {
      display: block;
      width: 100%;
    }

    img {
      width: 100%;
      height: auto;
      display: block;
      object-fit: cover;
    }

    .banner-btn-link {
      position: absolute;
      top: 75%;
      left: 9%;

      @media (max-width: 1366px) {
        top: 70%;
        left: 8%;
      }

      @media (max-width: 1024px) {
        top: 75%;
        left: 6%;
      }

      @media (max-width: 768px) {
        top: 100%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
`;
